/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { userRegistration } from "../../funcs/userRegistration.js";
import * as components from "../../models/components/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: components.UserRegistration$inboundSchema,
};

export const tool$userRegistration: ToolDefinition<typeof args> = {
  name: "user-registration",
  description: `Register a user and generate an API Key

Registers a user in Hedgewise and provides an API key`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await userRegistration(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(void 0, apiCall);
  },
};
